import { map } from 'rxjs';
import { getUnixTime } from 'date-fns';
import { ADMIN_API } from '../AdminAPI';
import { convertUnixToDate } from '@golden/gdk-base';
export function createManualService(api) {
    return {
        getWithdrawList(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(ADMIN_API.GET_MANUAL_WITHDRAW_LIST, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        getEffectiveBet(account, cash) {
            return api.fetch(ADMIN_API.GET_MANUAL_EFFECTIVE_BET, { data: { account, cash } });
        },
        getDepositList(payload) {
            const data = { ...payload };
            if (data.created_at_start)
                data.created_at_start = getUnixTime(data.created_at_start);
            if (data.created_at_end)
                data.created_at_end = getUnixTime(data.created_at_end);
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(ADMIN_API.GET_MANUAL_DEPOSIT_LIST, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'updated_at'))
            })));
        },
        getDepositProcesses() {
            return api.fetch(ADMIN_API.GET_MANUAL_DEPOSIT_PROCESS).pipe(map((res) => ({
                list: res.list.map((item) => convertUnixToDate(item, 'upload_at')),
                failed_list: res.failed_list.map((item) => convertUnixToDate(item, 'upload_at'))
            })));
        },
        deleteDepositProcess(id) {
            return api.fetch(ADMIN_API.DELETE_MANUAL_DEPOSIT_PROCESS, { config: { urlParams: { id } } });
        },
        retryDepositProcess(id) {
            return api.fetch(ADMIN_API.POST_MANUAL_DEPOSIT_PROCESS_RETRY, { config: { urlParams: { id } } });
        },
        createDeposit(data) {
            return api.fetch(ADMIN_API.POST_MANUAL_DEPOSIT, { data });
        },
        updateDepositBindingDeposits(data, id) {
            return api.fetch(ADMIN_API.PUT_MANUAL_DEPOSIT_BINDING_DEPOSITS, { data, config: { urlParams: { id } } });
        },
        createDepositByCsv(payload) {
            const data = new FormData();
            data.append('file', payload.file);
            data.append('deposit_type', payload.depositType);
            data.append('code', payload.code);
            data.append('is_excluding_specified_games', Number(payload.isExcludingSpecifiedGames).toString());
            data.append('multiple', payload.multiple);
            return api.fetch(ADMIN_API.POST_MANUAL_DEPOSIT_CSV, { data });
        },
        getEffectiveBetByDepositCsv(file) {
            const data = new FormData();
            data.append('file', file);
            return api.fetch(ADMIN_API.POST_WITHDRAW_BARRIERS_USER_INFO_CSV, { data });
        },
        createWithdraw(data) {
            return api.fetch(ADMIN_API.POST_MANUAL_WITHDRAW, { data });
        },
        createWithdrawByCsv(payload) {
            const data = new FormData();
            data.append('file', payload.file);
            data.append('withdraw_type', payload.withdrawType);
            return api.fetch(ADMIN_API.POST_MANUAL_WITHDRAW_CSV, { data });
        },
        getEffectiveBetByWithdrawCsv(file) {
            const data = new FormData();
            data.append('file', file);
            return api.fetch(ADMIN_API.POST_WITHDRAW_BARRIERS_USER_INFO_WITHDRAW_CSV, { data });
        },
        exportManualDeposit(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(ADMIN_API.GET_EXPORT_MANUAL_DEPOSIT_VALIDATE, { data });
        },
        exportManualWithdraw(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(ADMIN_API.GET_EXPORT_MANUAL_WITHDRAW_VALIDATE, { data });
        },
        getDepositDetail(data) {
            return api.fetch(ADMIN_API.GET_MANUAL_DEPOSIT_UPDATE_SERIAL_NUMBER, { data });
        },
        updateDepositDetail(data) {
            return api.fetch(ADMIN_API.PUT_MANUAL_DEPOSIT_UPDATE_SERIAL_NUMBER, { data });
        },
        getDepositBatch(data) {
            return api.fetch(ADMIN_API.GET_MANUAL_DEPOSIT_UPDATE_BATCH_ID, { data });
        },
        updateDepositBatch(data) {
            return api.fetch(ADMIN_API.PUT_MANUAL_DEPOSIT_UPDATE_BATCH_ID, { data });
        }
    };
}
//# sourceMappingURL=ManualService.js.map